import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
    QuestionBoldIcon,
    Dropdown,
    Popin,
    Box,
    Text,
} from '@paygreen/paygreen-ui';

const PopinInfo = ({
    colorPallet,
    colorStatus,
    children,
    popinPosition,
    popinWidth,
    popinPadding,
    message,
    ...rest
}) => (
    <Dropdown hasOverlay={false}>
        <Box>
            <QuestionBoldIcon
                htmlTag="button"
                colorPallet={colorPallet}
                colorStatus={colorStatus}
                hasHover={true}
                iconSize="xxs"
                marginLeft="xs"
                hasBackground={true}
                {...rest}
            />
        </Box>

        <Popin blockWidth={popinWidth} align={popinPosition} marginBottom="sm">
            <Box padding={popinPadding}>
                {message && (
                    <Text
                        textSize="xxs"
                        style={{ display: 'block', fontWeight: '400' }} // this style is necessary to override inherited style from DaTableHeadCell if this component is used in cell
                    >
                        {message}
                    </Text>
                )}

                {children}
            </Box>
        </Popin>
    </Dropdown>
);

PopinInfo.propTypes = {
    colorPallet: PropTypes.string,
    colorStatus: PropTypes.string,
    popinPosition: PropTypes.string,
    popinWidth: PropTypes.string,
    message: PropTypes.string,
    popinPadding: PropTypes.string,
};

PopinInfo.defaultProps = {
    colorPallet: 'status',
    colorStatus: 'default',
    popinPosition: PropTypes.string,
    popinWidth: 'md',
    popinPadding: 'sm',
};

export default withTranslation('common')(PopinInfo);
